export default __webpack_public_path__ + "static/media/Edge of Purgatorial Shadows.ccff3063.jpg";